module.exports = __webpack_public_path__ + "static/media/BHS.b7542bab.svg";